package link.erpango.quip.data.remote.ktor

import io.ktor.client.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.logging.*
import io.ktor.client.statement.*
import io.ktor.http.encodedPath
import link.erpango.quip.QuipConstants
import link.erpango.quip.data.IDataSource
import link.erpango.quip.utils.FileUtils

object HttpClientManager: IHttpClientManager {
    override var dataSource: IDataSource? = null
    override fun createHttpClientConfig(): HttpClientConfig<*>.() -> Unit {
        val config: HttpClientConfig<*>.() -> Unit = {
            install(HttpTimeout) {
                requestTimeoutMillis = QuipConstants.Http.requestTimeout
                connectTimeoutMillis = QuipConstants.Http.connectionTimeout
                socketTimeoutMillis  = QuipConstants.Http.socketTimeout
            }
            install(HttpCallValidator) {

                validateResponse { response: HttpResponse ->
                    FileUtils.log("debugresponse: $response ${response.status.value}")
                    when (response.status.value) {
                        in 200 .. 299 -> {
                            dataSource?.let { dataSource ->

                            }
                        }
                        in 300..399 -> throw RedirectResponseException(response, "")
                        in 400..499 -> throw ClientRequestException(response, "")
                        in 500..599 -> throw ServerResponseException(response, "")
                    }

                    if (response.status.value >= 600) {
                        throw ResponseException(response, "")
                    }
                }

                handleResponseExceptionWithRequest { cause: Throwable, request ->
                    val causeResponse = (cause as? ResponseException)?.response
                    FileUtils.log(
                        "Error - " +
                                "${causeResponse?.request?.url.toString().substringBeforeLast("?appId").substringBeforeLast("&appId")} -> " +
                                "${causeResponse?.status} (${(cause as? ResponseException)?.message})"
                    )
                    causeResponse?.let { response ->
                        if ((cause is ClientRequestException ||
                                    cause is RedirectResponseException ||
                                    cause is ServerResponseException)){
                            FileUtils.log(
                                "Error - " +
                                        "${response.request.url.toString().substringBeforeLast("?appId").substringBeforeLast("&appId")} -> " +
                                        "${response.status} (${cause.message})"
                            )
                        }
                    }
                }
            }
            install(Logging) {
                logger = object: Logger {
                    override fun log(message: String) {
                        /*Filtramos el mensaje a mostrar en el log*/
                        var requestUrl = message.substringAfter("REQUEST: ")
                            .substringBefore("METHOD:").trim()
                            .substringBeforeLast("?appId")
                            .substringBeforeLast("&appId")

                        val requestMethod = message.substringAfter("METHOD: HttpMethod(value=").substringBefore(")").trim()
                        val requestError = message.substringAfter("failed with exception: ").substringBefore(")").trim()

                        var responseUrl = message.substringAfter("FROM: ")
                            .substringBefore("\nCOMMON HEADERS").trim()
                            .substringBeforeLast("?appId")
                            .substringBeforeLast("&appId")

                        val responseMethod = message.substringAfter("METHOD: HttpMethod(value=").substringBefore(")").trim()
                        val responseCode = message.substringAfter("RESPONSE: ").substringBefore("METHOD:").trim()

                        // Extraer el body de la respuesta si existe
                        val responseBodyStart = message.indexOf("\n\n")
                        val responseBodyEnd = message.indexOf("\nCOMMON HEADERS", responseBodyStart)
                        var responseBody = ""
                        if (responseBodyStart > 0 && responseBodyEnd > responseBodyStart) {
                            responseBody = message.substring(responseBodyStart + 2, responseBodyEnd).trim()
                        }

                        // Extraer el body de la petición si existe
                        val requestBodyStart = message.indexOf("\n\n", message.indexOf("REQUEST:"))
                        val requestBodyEnd = message.indexOf("\nCOMMON HEADERS", requestBodyStart)
                        var requestBody = ""
                        if (requestBodyStart > 0 && requestBodyEnd > requestBodyStart) {
                            requestBody = message.substring(requestBodyStart + 2, requestBodyEnd).trim()
                        }

                        // Extraer headers de autorización para verificar token
                        val authHeader = message.substringAfter("Authorization: ").substringBefore("\n").trim()
                        val hasAuth = authHeader.isNotEmpty() && !authHeader.startsWith("[")
                        
                        val logEntry = if (message.startsWith("REQUEST")) {
                            if(message.startsWith("REQUEST:")) {//No error message
                                // Log request details including URL, method, and body
                                "📤 REQUEST -> $requestUrl ($requestMethod)" +
                                        "\n   Auth: ${if(hasAuth) "✅ Token presente (${authHeader.take(20)}...)" else "❌ Sin token"}" +
                                        if (requestBody.isNotEmpty()) "\n   Body: $requestBody" else ""
                            } else { //Error message
                                "❌ REQUEST ERROR -> ${requestUrl.substringAfter("REQUEST ")} | Error: $requestError" +
                                        if (requestBody.isNotEmpty()) "\n   Request Body: $requestBody" else ""
                            }
                        } else {
                            // Log response details including status code and body
                            val logText = "📥 RESPONSE -> $responseUrl ($responseMethod) $responseCode"
                            val fullLog = if (responseBody.isNotEmpty() && responseBody.length < 2000) {
                                "$logText\n   Body: $responseBody"
                            } else {
                                logText
                            }
                            
                            // Si hay error, añadir más contexto
                            if (responseCode.contains("4") || responseCode.contains("5")) {
                                fullLog + "\n   ⚠️ Código de estado de error detectado: $responseCode"
                            } else {
                                fullLog
                            }
                        }
                        
                        FileUtils.log(logEntry)
                    }
                }
                level = LogLevel.INFO
                // Las notas del asistente de importación no pasan por el log, ni aunque
                // se suba el nivel a BODY: contienen texto libre del usuario.
                filter { request -> !request.url.encodedPath.contains("extract-vehicles") }
            }

            install(TokenFeature) {
                tokenHeaderName = QuipConstants.Http.Headers.authorization
                tokenProvider = object: TokenFeature.TokenProvider {
                    override suspend fun getToken(): String? {
                        dataSource?.db?.auth?.selectCurrentLoggedUserId()?.let { currentUserId ->
                            val accessToken = dataSource?.db?.auth?.selectAccessToken(currentUserId)
                            val refreshToken = dataSource?.db?.auth?.selectRefreshToken(currentUserId)

                            dataSource?.let { dataSource ->
                                /*val needsToRefresh = checkJwtIsNextToExpiration(
                                    accessToken,
                                )
                                dataSource.cache.users.needToRefresh = needsToRefresh*/
                                /*val refreshTokenExpired = checkJwtExpiration(refreshToken)
                                if (refreshTokenExpired) {
                                    println("Refresh token expirado, se cierra sesión")
                                    dataSource.cache.users.setSessionExpired(true)
                                }*/
                            }
                            
                            // Log para debug del token
                            if (accessToken.isNullOrEmpty()) {
                                FileUtils.log("⚠️ WARNING: Access token is null or empty for user $currentUserId")
                            } else {
                                FileUtils.log("✅ Token obtenido para usuario $currentUserId (${accessToken.take(20)}...)")
                            }
                            
                            return if (accessToken.isNullOrEmpty()) ""
                            else QuipConstants.Http.Headers.jwt + " " + accessToken
                        } ?: run {
                            FileUtils.log("⚠️ WARNING: No user logged in, returning empty token")
                            return ""
                        }
                    }
                }
            }

            expectSuccess = true
        }

        return config
    }

   /* private fun checkJwtIsNextToExpiration(jwt: String?, treshold: Long): Boolean {
        return dataSource?.encoder?.let { encoder ->
            jwt?.let { jwt ->
                val jwtPayload = EncodingUtils.decodeJwt(jwt, base64 = encoder)
                val jwtExpiration = jwtPayload?.payload?.exp ?: 0 // si es null, lo consideramos expirado
                val now = DatetimeUtils.currentTimeMillis() / 1000
                jwtExpiration - now < treshold
            } ?: false
        } ?: false
    }

    private fun checkJwtExpiration(jwt: String?): Boolean {
        return dataSource?.encoder?.let { encoder ->
            jwt?.let { jwt ->
                val jwtPayload = EncodingUtils.decodeJwt(jwt, base64 = encoder)
                val jwtExpiration = jwtPayload?.payload?.exp ?: 0 // si es null, lo consideramos expirado
                val now = DatetimeUtils.currentTimeMillis() / 1000
                jwtExpiration < now
            } ?: false
        } ?: false
    }*/

    /*override fun isCurrentSession(sessionInfo: DSessionInfo): Boolean {
        var value = false
        try {
            val deviceId = dataSource?.cache?.common?.getSystemInfo()?.deviceId
            value = !sessionInfo.uuid.isNullOrEmpty() && sessionInfo.uuid == deviceId
        } catch (t: Throwable) {
            FileUtils.log("403. Error checking isCurrentSession ->$t")
        }
        return value
    }

    override suspend fun parseSessionInfo(responseBody: String): DSessionInfo? {
        var sessionInfo: DSessionInfo? = null
        try {
            responseBody.let {
                sessionInfo = jsonConfig.decodeFromString(DSessionInfo.serializer(), it)
            }
        } catch (e: Exception) {
            e.printStackTrace()
            val desc = e.message
            FileUtils.log("Forbidden -> not external session. $desc")
        } finally {
            return sessionInfo
        }
    }*/
}
